module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex align-center",
    class: _vm.addClass
  }, [_c('div', {
    class: {
      'input-with-icon': _vm.showIcon
    }
  }, [_c('div', {
    class: {
      'icon': _vm.showIcon,
      'icon-clock': _vm.showIcon
    }
  }), _vm._v(" "), _c('time-input', {
    attrs: {
      "date": _vm.startTime,
      "width": _vm.inputWidth
    },
    on: {
      "changed": _vm.setStartTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "timepicker timepicker-line"
  }, [_vm._v("\n    -\n  ")]), _vm._v(" "), _c('div', {
    class: {
      'input-with-icon': _vm.showIcon
    }
  }, [_c('div', {
    class: {
      'icon': _vm.showIcon,
      'icon-clock': _vm.showIcon
    }
  }), _vm._v(" "), _c('time-input', {
    attrs: {
      "date": _vm.endTime,
      "width": _vm.inputWidth
    },
    on: {
      "changed": _vm.setEndTime
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utcStart),
      expression: "utcStart"
    }],
    staticClass: "none",
    attrs: {
      "name": "event_start",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.utcStart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utcStart = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utcEnd),
      expression: "utcEnd"
    }],
    staticClass: "none",
    attrs: {
      "name": "event_end",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.utcEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utcEnd = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a451aae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeChanger.vue
// module id = 1866
// module chunks = 1